<div id="topToReview">
  <div class="more-ai-matched-card" *ngIf="!showLoaderbeforeDataLoad && projectDetails?.status != 'inactive'" >
    <p *ngIf="!showLoaderforReview">
      <i class="fa-regular fa-users"></i> Shortlist or Archive candidates curated for your criteria. Once reviewed, you
      can request to view more candidates.
    </p>
    <p *ngIf="showLoaderforReview">
      <i class="fa-regular fa-clock"></i>We're currently processing your request and working to bring you more tailored
      options.
    </p>
    <button data-testid="auto-app-ai-sourcing-review-button-1" class="btn-get-more-candidate" *ngIf="!showLoaderforReview"
      matTooltip="Almost there! Shortlist or Archive all ‘To Review’ candidates"
      [matTooltipClass]="{ 'red-tooltip text-black': true }"
      [ngClass]="{'active': reviewedProfiles?.length == 0 && projectDetails?.talenttotalstrength > 50 && !filterSelected && projectDetails?.talenteligiblestrength != projectDetails?.talentdisplayedsofar && !showReviwedCandidates}"
      (click)="reviewedProfiles?.length == 0 && projectDetails?.talenttotalstrength > 0 && !filterSelected && projectDetails?.talenteligiblestrength != projectDetails?.talentdisplayedsofar &&  getMoreCandidates()">Get
      More Candidates</button>
    <button data-testid="auto-app-ai-sourcing-review-button-2" class="btn-get-more-candidate" *ngIf="showLoaderforReview">Requested</button>

  </div>
  <div class="empty-card"
    *ngIf="reviewedProfiles?.length == 0 && !showLoaderforReview && !showLoaderbeforeDataLoad && !getToCheckIfFiltersApplied && (projectDetails?.talenteligiblestrength != projectDetails?.talentdisplayedsofar) && !showReviwedCandidates && !doNotshowReviewPage">
    <div>
      <span class="text-center">🎯</span>
      <p class="f-14 font-weight-500 mb-0">Click the ‘Get More Candidates’ button to view additional profiles.</p>
    </div>
  </div>
  <div class="empty-card" *ngIf="reviewedProfiles?.length == 0 && showLoaderforReview">
    <div>
      <span class="text-center">🎯</span>
      <p class="f-16 font-weight-600 mb-2">You have successfully screened all candidates.</p>
      <p class="f-14 font-weight-normal mb-3">Since you've already requested more, we're now working behind the scenes
        to source profiles that better match your criteria.</p>
      <p class="f-14 font-weight-500 mb-0">You’ll be notified as soon as new candidates are ready to review.</p>
      <p class="f-14 font-weight-500 mb-0">Click the ‘Get More Candidates’ button to view additional profiles.</p>
    </div>
  </div>
</div>

<!-- No review data are available screen -->
<div class="wccard" style="height: 470px;"
  *ngIf="(reviewedProfiles?.length == 0 && ((projectDetails?.talenteligiblestrength == 0) || (showReviwedCandidates) || (projectDetails?.talenteligiblestrength == projectDetails?.talentdisplayedsofar))) && !showLoaderbeforeDataLoad && projectDetails?.aisourcingstatus != 'started'">
  <div class="text-center">
    <div class="text-center">
      <img src="../../../assets/shortlist.png" alt="img-fluid" class="img-config">
    </div>
    <p class="f-14 font-weight-500 mb-0 text-center">No Candidates Found.</p>
    <p class="f-14 font-weight-500 text-9696 text-center">A small tweak in your Autopilot<sup><span>AI</span></sup>
      criteria could unlock the right matches.</p>
    <button data-testid="auto-app-ai-sourcing-review-button-3" class="btn-trms-regular criteria-btn mb-2" (click)="redirectToEditCriteria()">Edit Criteria</button>
    <p class="f-14"><i class="fa-light fa-lightbulb-on mr-1 "></i>Want help - <a data-testid="auto-app-ai-sourcing-review-a-1" (click)="openHelpModal()" class="mr-1"
        style="color: #2E93A1;">Learn More <i class="fa-solid fa-arrow-up-right-from-square"></i></a></p>
  </div>
</div>
<div class="wccard" *ngIf="(reviewedProfiles?.length == 0 && !showLoaderbeforeDataLoad && candidateStatus== 'error')"
  style="height: 300px;">
  <div class="text-center">
    <div class="text-center">
      <img src="../../../assets/shortlist.png" alt="img-fluid" class="img-config">
    </div>
    <p class="f-14 font-weight-500 mb-0 text-center">Something went wrong.</p>
    <p class="f-14 font-weight-500 text-9696 text-center">Don’t worry—re-run sourcing and we’ll handle the rest..</p>
    <button data-testid="auto-app-ai-sourcing-review-button-4" class="btn-trms-regular criteria-btn mb-2" (click)="redirectToEditCriteria()">Explore Candidate</button>
  </div>
</div>

<div class="wccard" *ngIf="getToCheckIfFiltersApplied && !showLoaderbeforeDataLoad" style="height: 300px;">
  <div class="text-center">
    <div class="text-center">
      <img src="../../../assets/shortlist.png" alt="img-fluid" class="img-config">
    </div>
    <p class="f-14 font-weight-500 mb-0 text-center">No Matching Candidate.</p>
    <p class="f-14 font-weight-500 text-9696 text-center">No results found with the selected filters.</p>
    <p>Please modify your filters or click ‘Get More Candidates’ to <br> explore additional profiles</p>
  </div>
</div>
<div class="wccard p-3" *ngIf="projectDetails?.aisourcingstatus == 'started'">
  <div class="text-center">
    <p class="f-16 font-weight-600">Autopilot<sup style="top: -1px !important;"><span>AI</span></sup> criteria
      successfully updated</p>
    <p class="f-14">Please wait while we’re generating result </p>
    <div class="progress-container mt-1">
      <div>
        <span class="status-btn live-status">
          <i class="fa-solid" [ngClass]="progress === 100 ? 'fa-circle-check' : 'fa-spinner'"></i>
          {{ progress === 100 ? 'Loaded Results' : 'Generating Results'}} {{progress}}%
        </span>
      </div>
    </div>
  </div>
</div>
<app-blurbackdrop *ngIf="(projectDetails?.status == 'inactive' || reviewpageAccessBlocked)"></app-blurbackdrop>
<!-- <div class="position-relative">
<div class="backdrop-blur" id="backdropdiv">
</div>
 <div class="sub-modal" id="centermodal">
    test
  </div>
  </div> -->
<div *ngIf="reviewedProfiles?.length > 0 && !showLoaderbeforeDataLoad">
  <div *ngFor="let candidate of reviewedProfiles; let i = index">
    <app-ai-sourcing-profile-card [data]="candidate" [selectedCandididate]="selectedCandididate" [calledfrompage]="'reviewpage'" [index]="i"
      (childEvents)="eventHandler($event)">
      <div talentPoolBulkGrab>
        <label class="wc-checkbox mr-2">
          <input data-testid="auto-app-ai-sourcing-review-input-1" [checked]="candidate.selected" [(ngModel)]="candidate.selected"
            (change)="selectCandidate($event, candidate)" type="checkbox" id="mycheck" name="mycheck">
          <i class="fas fa-check"></i>
        </label>
      </div>

    </app-ai-sourcing-profile-card>
  </div>

</div>

<div class="h-50 justify-content-center d-flex flex-column" *ngIf="showLoaderbeforeDataLoad || projectDetails?.aisourcingstatus == 'pending'">
  <div *ngFor="let i of [1,2,3,4,5]">
    <app-ai-sourcing-profile-skeleton></app-ai-sourcing-profile-skeleton>
  </div>
</div>


<div class="row justify-content-start">
  <div id="overlay" (click)="closeNav()">
  </div>
</div>

<div id="quickView">
  <div class="pr-3" *ngIf="showCandidate">
    <app-person-search-candidate-slider [data]="currentCandidate" [viewMoreSkills]="viewMoreSkills"
      [highlightkeywords]="highlightkeywords" [tabType]="tabType" (childEvents)="eventHandler($event)"
      (handleOutputEvent)="eventHandler($event)" [currentIndex]="currentIndex" [calledfrompage]="'reviewpage'">
      <div shortlist class="pb-2">
        <div class="d-flex">
          <button data-testid="auto-app-ai-sourcing-review-button-5" class="btn-trms-regular archive" style="width: 50%;"
            (click)="changeCandidateStatus(currentCandidate, 'archive')">
            <i class="fa-solid fa-user-minus"></i> Archive
          </button>
          <button data-testid="auto-app-ai-sourcing-review-button-6" class="ml-2 btn-trms-regular px-0" style="width: 50%;"
            (click)="changeCandidateStatus(currentCandidate,'shortlisted')">
            <i class="fa-solid fa-user-plus mr-1"></i>Shortlist
          </button>

        </div>
      </div>


    </app-person-search-candidate-slider>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<!-- Access management modal templates -->
<!-- <ng-template #accessManagementModal class="modal">
  <div class="modal-content p-3">
    <div class="text-center justify-content-between align-items-center">
      <p class="f-14 font-weight-600">This Job is Inactive</p>
      <p> To continue sourcing, please increase your team’s active project slots or contact Admin to deactivate another
        active project and activate this one.</p>
      <div class="d-flex justify-content-center gap-3 mt-4">
        <button data-testid="auto-app-ai-sourcing-review-button-7" class="btn-trms-white px-4 mr-3" (click)="dismiss()">Cancel</button>
        <button data-testid="auto-app-ai-sourcing-review-button-8" class="btn-trms-small px-4" (click)="notifyAdmin()">Notify Admin</button>
      </div>
    </div>
  </div>
</ng-template> -->
